// extracted by mini-css-extract-plugin
export default {"container":"MainBlock_container__OqT1N","text":"MainBlock_text__HxLeM"};